import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
    selector: '[appFeature]',
})
export class FeatureDirective {
    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

    @Input()
    set appFeature(val: string) {
        let negate = false;
        val = val.trim();
        if (val.charAt(0) === '!') {
            negate = true;
            val = val.substring(1);
        }
        if (negate ? !environment.feature[val] : environment.feature[val]) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
